export const laws = {
  page_header_title: "Gesetze A-Z",
  page_header_subtitle:
    "Alle Gesetze in alphabetischer Reihenfolge durchsuchen",
};
